"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.processArgvCommand = function (tsGit, argv) { return __awaiter(void 0, void 0, void 0, function () {
    var command, dir, type, object, type, write, filePath, success, message;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                command = argv._[1];
                if (!!command) return [3 /*break*/, 4];
                if (!argv.version) return [3 /*break*/, 2];
                return [4 /*yield*/, tsGit.version()];
            case 1: return [2 /*return*/, _a.sent()];
            case 2: return [2 /*return*/, Promise.resolve(helpResult)];
            case 3: return [3 /*break*/, 8];
            case 4:
                if (!(command === 'help')) return [3 /*break*/, 5];
                return [2 /*return*/, Promise.resolve(helpResult)];
            case 5:
                if (!(command === 'version')) return [3 /*break*/, 7];
                return [4 /*yield*/, tsGit.version()];
            case 6: return [2 /*return*/, _a.sent()];
            case 7:
                if (command === 'init') {
                    dir = argv._[2] || '.';
                    return [2 /*return*/, tsGit.init(dir)];
                }
                else if (command === 'cat-file') {
                    type = argv._[2];
                    if (!['blob', 'commit', 'tag', 'tree'].includes(type)) {
                        return [2 /*return*/, Promise.resolve({
                                success: false,
                                message: "Usage: ts-git cat-file <type> <object>\n<type> can be one of: blob, tree, commit, tag",
                            })];
                    }
                    object = argv._[3] || '';
                    return [2 /*return*/, tsGit.catFile('.', type, object)];
                }
                else if (command === 'hash-object') {
                    type = argv.t;
                    if (type && !['blob', 'commit', 'tag', 'tree'].includes(type)) {
                        return [2 /*return*/, Promise.resolve({
                                success: false,
                                message: "Usage: ts-git hash-object [-t <type>] [-w] <file>\n<type> can be one of: blob, tree, commit, tag",
                            })];
                    }
                    write = Boolean(argv.w);
                    filePath = argv._[2] || '';
                    return [2 /*return*/, tsGit.hashObject('.', filePath, write, type)];
                }
                else if (command === 'log') {
                    return [2 /*return*/, tsGit.log('.', argv._[2])];
                }
                else {
                    success = false;
                    message = "ts-git doesn't know how to execute the \"" + command + "\" command.\n\nThis is either because you entered an invalid command or because ts-git hasn't implemented the feature you just tried.\n\n(It's probably the latter :) )\n\nTo see a list of all the commands you _can_ use, run \"ts-git --help\"";
                    return [2 /*return*/, Promise.resolve({ success: success, message: message })];
                }
                _a.label = 8;
            case 8: return [2 /*return*/];
        }
    });
}); };
var helpResult = {
    success: true,
    message: "usage: ts-git <command> [<args>]\n\nHere is the complete list of commands implemented by ts-git:\n\nts-git init [directory]\n  Create an empty ts-git repository\n\nts-git log <object>\n  Shows the commit logs\n\nts-git cat-file <type> <object>\n  Provide content or type and size information\n  for repository objects\n\nts-git hash-object [-t <type>] [-w] <file>\n  Compute object ID and optionally creates\n  a blob from a file\n",
};
